import React from "react";
import "../styles/TermsAndConditions.css";

const Privacypolicy = () => {
  return (
    <div className="section terms-container">
      <h1 className="heading-secondary">Politica de confidențialitate</h1>
      <h2 className="terms-subheader">Dispoziții generale</h2>
      <p className="terms-paragraph">
        Acest site este deținut de Florelite Design SRL. La înregistrarea
        comenzii în magazinul online, cumpărătorul acceptă Termenii și
        Condițiile de vânzare a bunurilor/produselor și/sau prestare a
        serviciilor care sunt bazați pe legislația Republicii Moldova.
        <p>
          Utilizarea website-ului presupune acceptarea Termenilor și Condițiilor
          propuse de către FLorelite Design SRL, în conformitate cu Legea
          nr.284/2004 privind Comerțul Electronic. Relațiile dintre client și
          vânzător sunt stabilite în baza Legii nr.105/2003 cu privire la
          Protecția drepturilor consumatorului, și a altor acte normative
          adoptate în conformitate cu aceasta.
        </p>
        <p>
          Vânzătorul își rezervă dreptul de a modifica Termenii și Condițiile
          date, iar Cumpărătorul este obligat să monitorizeze modificările.
        </p>
      </p>

      <h2 className="terms-subheader">
        Protecția datelor cu caracter personal
      </h2>
      <p className="terms-paragraph">
        Prin utilizarea site-ului gardeniaflowers.md, sunteți de acord în mod
        automat cu colectarea și prelucrarea datelor cu caracter personal, care
        sunt necesare pentru procesarea/confirmarea/executarea comenzilor.
        <p>
          Datele personale se prelucrează doar pentru scopuri legitime, precum
          acela de a furniza produsele pe care le comandați, promoții, google
          analytics, cookies și notificări newsletter.
        </p>
        <p>
          Toată informația ce conține date cu caracter personal este stocată și
          utilizată doar pentru perioada necesară atingerii scopurilor pentru
          care a fost colectată și în conformitate cu prevederile stabilite de
          Legea nr. 133/2011 privind protecția datelor cu caracter personal.
        </p>
        <p>
          Noi folosim măsuri de securitate comerciale pentru a preveni accesul
          neautorizat, menținerea exactității datelor și pentru asigurarea
          utilizării corecte a informației de pe site. Transmiterea datelor pe
          internet sau prin rețea wireless nu poate fi protejată în totalitate.
          Prin urmare, la fel ca alte companii, noi nu putem garanta securitatea
          informației pe care o oferă Cumpărătorul, astfel, el va face acest
          lucru pe propria răspundere.
        </p>
      </p>

      <h2 className="terms-subheader">Politica de confidențialitate</h2>
      <p className="terms-paragraph">
        În conformitate cu prevederile Legii Nr.133/2011 privind protecția
        datelor cu caracter personal, furnizorul de servicii prelucrează date cu
        caracter personal. Datele cu caracter personal sunt prelucrate cu
        bună-credință și se face în temeiul și în conformitate cu prevederile
        legale. Prelucrarea datelor cu caracter personal se realizează prin
        mijloace mixte (automate și manuale), cu respectarea cerințelor legale
        și în condiții care să asigure securitatea, confidențialitatea și
        respectarea drepturilor persoanelor vizate.
      </p>
      <p className="terms-paragraph">
        Furnizorul colectează și prelucrează doar datele personale furnizate de
        consumatori la efectuarea comenzii: nume, prenume, număr de telefon,
        adresa, adresa poștală.
      </p>

      <p className="terms-paragraph">
        Datele personale sunt utilizate exclusiv în scopul administrării
        site-ului, pentru a permite accesul la informații speciale, pentru
        livrarea comenzilor sau pentru a contacta consumatorul în vederea
        executării livrării. Prin prezenta informare, utilizatorii și
        consumatorii iau cunoștință despre faptul că li se vor prelucra și
        utiliza datele cu caracter personal (nume, prenume, număr de telefon,
        adresa, adresa poștală). Furnizorul de servicii prelucrează datele cu
        caracter personal ale utilizatorilor și consumatorilor care sunt
        furnizate prin navigarea, folosirea și înregistrarea pe site-ul
        gardeniaflowers.md.
      </p>
      <p className="terms-paragraph">
        Orice informație furnizată de către utilizatorii și consumatorii
        site-ului gardeniaflowers.md, va fi considerată și va reprezenta
        consimțământul expres ca datele personale să fie folosite de Furnizor.
      </p>
      <p className="terms-paragraph">
        Furnizorul nu va dezvălui unei terțe părți niciuna dintre datele
        deținute, fără acordul persoanelor vizate și nu va comercializa,
        schimba, divulga aceste date cu alte persoane, cu excepțiile prevăzute
        de legislația în vigoare (la solicitarea instituțiilor publice ale
        statului, organele de drept, instanțelor de judecată, de asemenea
        autorizate să prelucreze date cu caracter personal).
      </p>
      <p className="terms-paragraph">
        Angajații furnizorului de servicii sunt obligați să respecte
        confidențialitatea datelor personale ale consumatorilor. Prelucrarea
        datelor cu caracter personal va fi realizată de persoana împuternicită a
        Furnizorului.
      </p>
      <p className="terms-paragraph">
        Furnizorul utilizează metode și tehnologii de securitate conform
        prevederilor legale în vigoare.
      </p>
      <p className="terms-paragraph">
        Furnizorul nu colectează informații referitoare la tranzacții, cum ar fi
        nr. la card, data expirării, țara de origine.
      </p>
      <p className="terms-paragraph">
        Dacă aveți întrebări sau comentarii cu privire la Politica noastră de
        confidențialitate, vă rugăm să ne contactați prin e-mail la adresa
        info@gardeniaflowers.md
      </p>

      <h2 className="terms-subheader">Date de contact</h2>
      <p className="terms-paragraph">
        Denumirea juridică a companiei: FLORELITE DESIGN SRL
        <p>IDNO: 1022600015904</p>
        <p>Adresa juridică: mun. Chișinău, Str. Nicolae Costin 65/3, 17 </p>
        <p>Adresa fizică: mun. Chișinău, Str. Petru Rares 37</p>
        <p>Telefon de contact: +373 78 774 774</p>
        <p>Email: order@gardeniaflowers.info</p>
      </p>
    </div>
  );
};

export default Privacypolicy;
